// theme.js

const theme = {
  colors: {
    purple: '#9013FE',
  },
  fonts: {
  	h1: "Abril Fatface, Georgia, Times New Roman, slab-serif",
  	h2: "Roboto, Helvetica, sans-serif",
  	h3: "Roboto Condensed, Helvetica Condensed, Helvetica Neue, Helvetica, sans-serif",
  	h4: "Roboto, Helvetica Neue, Helvetica, sans-serif",
  	h5: "Helvetica Neue, Helvetica, sans-serif",
  }

}


export default theme


// WEBPACK FOOTER //
// ./src/theme.js